import styled from "@emotion/styled";
import { AnimatePresence } from "framer-motion";

import type { PlayerInfo, SelectArticleView, WordPickerView, VotingView } from "../protocol";

import {
    MsScreen, MsBody, MsEyebrow, MsStamp, MsDisplay, MsChip,
    MaskHeadline, Dots,
    Stack,
} from "../ms";

const ChipRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    max-width: 320px;
    margin: 0 auto;
`;

const WaitingBody = styled(MsBody)`
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 22px;
`;

const WaitingHeadline = styled(MsDisplay)`
    font-size: 36px;
`;


type WaitingView = SelectArticleView | WordPickerView | VotingView;

export default function WaitingForPlayers({ view }: { view: WaitingView }) {
    const awaiting = view.awaitingPlayers || [];

    return (
        <MsScreen>
            <WaitingBody>
                <Stack gap={18} align="center">
                    <MsStamp>Stand by</MsStamp>
                    <WaitingHeadline>
                        <MaskHeadline>Waiting for players.</MaskHeadline>
                    </WaitingHeadline>
                    <Dots />
                    {awaiting.length > 0 && (
                        <>
                            <MsEyebrow tone="mute">
                                Still {awaiting.length === 1 ? "out" : "out"} · {awaiting.length}
                            </MsEyebrow>
                            <ChipRow>
                                <AnimatePresence>
                                    {awaiting.map((p: PlayerInfo) => (
                                        <MsChip
                                            key={p.id}
                                            layout
                                            initial={{ opacity: 0, scale: 0.85, y: 8 }}
                                            animate={{ opacity: 1, scale: 1, y: 0 }}
                                            exit={{ opacity: 0, scale: 0.85, y: -8 }}
                                        >
                                            {p.name}
                                        </MsChip>
                                    ))}
                                </AnimatePresence>
                            </ChipRow>
                        </>
                    )}
                </Stack>
            </WaitingBody>
        </MsScreen>
    );
}
